import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './style';
import MessengerChat from './MessengerChat';

const CopilotTestChat = ({
  title,
  description,
  onSend,
  firstMessage,
  messageAuthor,
  askAnotherMessage,
  newMessageNormalizer,
  isAnimating,
  shouldPromptForAnotherQuestion,
  messageAvatarUrl,
  placeholder,
  showClearButton,
  onClear,
  suggestions
}) => {
  return (
    <Styled.Aside>
      {title && <Styled.AsideTitle>{title}</Styled.AsideTitle>}
      {description && <Styled.AsideDescription>{description}</Styled.AsideDescription>}
      <MessengerChat
        onSend={onSend}
        firstMessage={firstMessage}
        messageAvatarUrl={messageAvatarUrl}
        messageAuthor={messageAuthor}
        askAnotherMessage={askAnotherMessage}
        newMessageNormalizer={newMessageNormalizer}
        isAnimating={isAnimating}
        shouldPromptForAnotherQuestion={shouldPromptForAnotherQuestion}
        placeholder={placeholder}
        suggestions={suggestions}
        showClearButton={showClearButton}
        onClear={onClear}
      />
    </Styled.Aside>
  );
};

CopilotTestChat.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  firstMessage: PropTypes.string.isRequired,
  askAnotherMessage: PropTypes.string.isRequired,
  newMessageNormalizer: PropTypes.func.isRequired,
  onSend: PropTypes.func.isRequired,
  isAnimating: PropTypes.bool,
  shouldPromptForAnotherQuestion: PropTypes.bool,
  messageAuthor: PropTypes.string,
  placeholder: PropTypes.string,
  messageAvatarUrl: PropTypes.string,
  suggestions: PropTypes.arrayOf(PropTypes.string),
  showClearButton: PropTypes.bool,
  onClear: PropTypes.func
};

CopilotTestChat.defaultProps = {
  isAnimating: false,
  shouldPromptForAnotherQuestion: true,
  messageAuthor: 'Magic AI',
  suggestions: [],
  messageAvatarUrl: null,
  placeholder: 'Write your test request or issue here',
  showClearButton: false,
  onClear: null
};

export default CopilotTestChat;
